import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as filesApi from "@api/files.api";
import type { UploadedFile } from "@/types";

interface FilesState {
  files: UploadedFile[];
  total: number;
  loading: boolean;
}

const initialState: FilesState = {
  files: [],
  total: 0,
  loading: false,
};

export const fetchFiles = createAsyncThunk(
  "files/fetchFiles",
  async ({ page, limit }: { page?: number; limit?: number } = {}) => {
    return await filesApi.getFiles(page, limit);
  },
);

export const uploadFiles = createAsyncThunk("files/uploadFiles", async (formData: FormData) => {
  return await filesApi.uploadFiles(formData);
});

export const deleteFile = createAsyncThunk("files/deleteFile", async (id: string) => {
  await filesApi.deleteFile(id);
  return id;
});

const filesSlice = createSlice({
  name: "files",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFiles.fulfilled, (state, action) => {
        state.files = action.payload.data;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(fetchFiles.rejected, (state) => {
        state.loading = false;
      })
      .addCase(uploadFiles.fulfilled, (state, action) => {
        state.files = [...action.payload, ...state.files];
        state.total += action.payload.length;
      })
      .addCase(deleteFile.fulfilled, (state, action) => {
        state.files = state.files.filter((f) => f.id !== action.payload);
        state.total -= 1;
      });
  },
});

export default filesSlice.reducer;
